import onRlinkEvent from 'rlink-reliclink/onRlinkEvent';
import lookupMeta from 'rlink-data-connector/lookupMeta';
import embedded from 'rlink-data-connector/embedded';

export default function accumulateClientEvent ({
  eventName,
  mapResponse,
}) {
  return ({
      fetchStarted,
      fetchCompleted,
      fetchFailed,
      getCaches,
      request,
      requestArgs,
  }) => {
    let {hasData} = lookupMeta(getCaches(), request, ...requestArgs);
    if (!hasData) {
      fetchCompleted(embedded(request, requestArgs, request.emptyValue, {hasData: false, mapped: true}));
    }
    onRlinkEvent({eventName}, ({eventData}) => {
      fetchCompleted(embedded(request, requestArgs, mapResponse(eventData)));
    }, request.keyFor(...requestArgs));
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/fetching/accumulateClientEvent.js